import { render, staticRenderFns } from "./saltruinfoimp.vue?vue&type=template&id=ce7996d0&scoped=true&"
import script from "./saltruinfoimp.vue?vue&type=script&lang=js&"
export * from "./saltruinfoimp.vue?vue&type=script&lang=js&"
import style0 from "./saltruinfoimp.vue?vue&type=style&index=0&id=ce7996d0&lang=scss&scoped=true&"
import style1 from "./saltruinfoimp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7996d0",
  null
  
)

export default component.exports